import { gql } from "@apollo/client";

export const ACA_ADMIN_SETTINGS_SNAPSHOT = gql`
    mutation AcaAdminSettingsSnapshot {
        acaAdminSettingsSnapshot {
            success
            error
            providers { id name status }
            mappings { state providerId name }
            codes { id description status }
            complianceReasons { id description status }
            tier2UserOptions { id displayName email }
            tier2Agents { id displayName email npnNumber agentActive npnActive stateSummary 
                licenses { id stateCode licenseNumber expirationDate active}
            }
        }
    }
`;

export const ACA_ADMIN_CREATE_TIER2_AGENT = gql`
    mutation AcaAdminCreateTier2Agent(
        $userId: Int!
        $npnNumber: String!
        $agentActive: Boolean!
    ) {
        acaAdminCreateTier2Agent(
            userId: $userId
            npnNumber: $npnNumber
            agentActive: $agentActive
        ) {
            success
            error
            agent {
                id
                displayName
                email
                npnNumber
                agentActive
                npnActive
                stateSummary
                licenses {
                    id
                    stateCode
                    licenseNumber
                    expirationDate
                    active
                }
            }
        }
    }
`;

export const ACA_ADMIN_ADD_TIER2_LICENSE = gql`
    mutation AcaAdminAddTier2License(
        $agentId: Int!
        $stateCode: String!
        $licenseNumber: String!
        $expirationDate: String
        $active: Boolean!
    ) {
        acaAdminAddTier2License(
            agentId: $agentId
            stateCode: $stateCode
            licenseNumber: $licenseNumber
            expirationDate: $expirationDate
            active: $active
        ) {
            success
            error
            license {
                id
                stateCode
                licenseNumber
                expirationDate
                active
            }
        }
    }
`;

export const ACA_ADMIN_SET_TIER2_AGENT_ACTIVE = gql`
    mutation AcaAdminSetTier2AgentActive($agentId: Int!, $active: Boolean!) {
        acaAdminSetTier2AgentActive(agentId: $agentId, active: $active) {
            success
            error
        }
    }
`;

export const ACA_ADMIN_SET_TIER2_AGENT_NPN_NUMBER = gql`
    mutation acaAdminSetTier2AgentNpnNumber($agentId: Int!, $npnNumber: String!) {
        acaAdminSetTier2AgentNpnNumber(agentId: $agentId, npnNumber: $npnNumber) {
            success
            error
        }
    }
`;

export const ACA_ADMIN_UPDATE_TIER2_LICENSE = gql`
    mutation acaAdminUpdateTier2License(
        $licenseId: Int!
        $stateCode: String!
        $licenseNumber: String!
        $expirationDate: String
        $active: Boolean!
    ) {
        acaAdminUpdateTier2License(
            licenseId: $licenseId
            stateCode: $stateCode
            licenseNumber: $licenseNumber
            expirationDate: $expirationDate
            active: $active
        ) {
            success
            error
            license {
                id
                stateCode
                licenseNumber
                expirationDate
                active
            }
        }
    }
`;

export const ACA_ADMIN_CREATE_PROVIDER = gql`
    mutation AcaAdminCreateProvider($name: String!) {
        acaAdminCreateProvider(name: $name) { success error }
    }
`;

export const ACA_ADMIN_SET_PROVIDER_STATUS = gql`
    mutation AcaAdminSetProviderStatus($id: Int!, $status: String!) {
        acaAdminSetProviderStatus(id: $id, status: $status) { success error }
    }
`;

export const ACA_ADMIN_ADD_PROVIDER_STATE = gql`
    mutation AcaAdminAddProviderState($providerId: Int!, $state: String!) {
        acaAdminAddProviderState(providerId: $providerId, state: $state) { success error }
    }
`;

export const ACA_ADMIN_REMOVE_PROVIDER_STATE = gql`
    mutation AcaAdminRemoveProviderState($providerId: Int!, $state: String!) {
        acaAdminRemoveProviderState(providerId: $providerId, state: $state) { success error }
    }
`;

export const ACA_ADMIN_ADD_FAILED_REASON = gql`
    mutation AcaAdminAddFailedReason($description: String) {
        acaAdminAddFailedReason(description: $description) { success error }
    }
`;

export const ACA_ADMIN_SET_FAILED_REASON_STATUS = gql`
    mutation AcaAdminSetFailedReasonStatus($id: Int!, $status: String!) {
        acaAdminSetFailedReasonStatus(id: $id, status: $status) { success error }
    }
`;

export const ACA_GET_FAILED_REASONS = gql`
    mutation AcaGetFailedReasons{
        acaGetFailedReasons {
            success
            error
            failedReasons {
                id
                description
                status
            }
        }
    }
`;


export const ACA_GET_SUMMARY_INFO = gql`
  mutation acaGetSummaryInfo($timeFrame: String) {
    acaGetSummaryInfo(timeFrame: $timeFrame) {
      success
      error
      contactSummary {
        status
        count
      }
      opportunityStagesSummary {
        name
        count
      }
      opportunityStatusesSummary {
        status
        count
      }
      opportunityRecentChanges {
        contactId
        firstName
        lastName
        contactStatus
        phone
        email
        addressState
        opportunityId
        assignedUserName
        assignedUserRef
        opportunityStatus
        stage
        lastUpdatedDatetime
        createdDatetime
        dataOnly
        medicaidEnrolled
        expireSoon
        incomeOrEmployment
        moveMedicaidBenefit
        medicareEnrolled
        employmentStatus
        sepQualification
        sepPreviousZip 
      }
      opportunityRecentChangesByUser {
        contactId
        firstName
        lastName
        contactStatus
        phone
        email
        addressState
        opportunityId
        assignedUserName
        assignedUserRef
        opportunityStatus
        stage
        stageId
        lastUpdatedDatetime
        createdDatetime
        agentFusionId
        dataOnly
        medicaidEnrolled
        expireSoon
        incomeOrEmployment
        moveMedicaidBenefit
        medicareEnrolled
        employmentStatus
        sepQualification
        sepPreviousZip  
      }
    }
  }
`;


export const ACA_GET_PIPELINE_INFO = gql`
  mutation acaGetPipelineInfo($stageId: Int, $pageSize: Int, $currentPage: Int, $orderColumn: String, $orderDirection: String, $filterColumn: String, $filterValue: String) {
    acaGetPipelineInfo(stageId: $stageId, pageSize: $pageSize, currentPage: $currentPage, orderColumn: $orderColumn, orderDirection: $orderDirection, filterColumn: $filterColumn, filterValue: $filterValue) {
      success
      error
      stagesSummary {
        name
        count
        id
      }
      contactStateSummary {
        stageName
        stageId
        state
        count
      }
      pagination {
        pageSize
        currentPage
        numOfPages
        totalCount
      }
      stageId 
      stageName
      opportunities {
        contactId
        firstName
        lastName
        contactStatus
        phone
        email
        addressState
        opportunityId
        assignedUserName
        assignedUserRef
        createdByUserIdRef
        createdByUserName
        opportunityStatus
        stage
        stageId
        source
        lastUpdatedDatetime
        createdDatetime
        agentFusionId
        dataOnly
        complianceFlag
        complianceReasonId
        complianceReasonText
        medicaidEnrolled
        expireSoon
        incomeOrEmployment
        moveMedicaidBenefit
        medicareEnrolled
        employmentStatus
        sepQualification
        sepPreviousZip
      }
    }
  }
`;

export const ACA_GET_OPPORTUNITY = gql`
  mutation acaGetOpportunity($opportunityId: Int) {
    acaGetOpportunity(opportunityId: $opportunityId) {
      success
      error
      opportunity {
        opportunityId
        contactId
        status
        stageId
        stageName
        createdDatetime
        lastUpdatedDatetime
        carrierProvider
        carrierState
        carrierMemberCount
        source
        failedReasonCode
        cancelledTerminated
        assignedUserRef
        assignedUserName
        createdByUserIdRef
        createdByUserName
        pipelineId
        leadSignedPdfId
        aorSignedPdfId
        signatureFileId
        customField1
        customField2
        agentFusionId
        dataOnly
        complianceFlag
        complianceReasonId
        complianceReasonText
        verificationDate
        medicaidEnrolled
        expireSoon
        incomeOrEmployment
        moveMedicaidBenefit
        medicareEnrolled
        employmentStatus
        sepQualification
        sepPreviousZip
        verificationDataRequested {
            id
            contactOpportunityId
            documentTypeId
            documentName
            possibleDocuments
            createdDatetime
            stageId
            stageName
        }
      }
    }
  }
`;

export const ACA_GET_CONTACT = gql`
  mutation acaGetContact($contactId: Int) {
    acaGetContact(contactId: $contactId) {
      success
      error
      contact {
        contactId
        status
        fusionCustomerId
        etc
        annualIncome
        firstName
        middleName
        lastName
        suffix
        email
        phone
        addressLine1
        addressLine2
        addressCity
        addressState
        addressZip
        ssn
        dob
        employmentType
        employmentDescription
        mainDoctor
        medications
        smoker
        createdDatetime
        photo1Id
        photo2Id
        dependentCount
        source
        createdByUserId
        lastUpdatedDatetime
      }
      opportunities {
        contactId
        firstName
        lastName
        contactStatus
        phone
        email
        addressState
        opportunityId
        assignedUserName
        assignedUserRef
        createdByUserIdRef
        createdByUserName
        opportunityStatus
        stage
        stageId
        source
        lastUpdatedDatetime
        createdDatetime
        customField1
        customField2
        failedReasonCode
        carrierMemberCount
        carrierProvider
        carrierState
        agentFusionId
        dataOnly
        medicaidEnrolled
        expireSoon
        incomeOrEmployment
        moveMedicaidBenefit
        medicareEnrolled
        employmentStatus
        sepQualification
        sepPreviousZip 
      }
      notes {
        noteId
        contactId
        noteText
        lastUpdatedDatetime
        createdDatetime
        userRef
        userName
      }
      dependents {
        createdDatetime
        dob
        firstName
        id
        lastName
        middleName
        ssn
        suffix
        contactId
      }
    }
  }  
`;

export const ACA_GET_CONTACT_UNMASKED = gql`
  mutation acaGetContactUnmasked($contactId: Int) {
    acaGetContactUnmasked(contactId: $contactId) {
      success
      error
      contact {
        contactId
        status
        fusionCustomerId
        etc
        annualIncome
        firstName
        middleName
        lastName
        suffix
        email
        phone
        addressLine1
        addressLine2
        addressCity
        addressState
        addressZip
        ssn
        dob
        employmentType
        employmentDescription
        mainDoctor
        medications
        smoker
        createdDatetime
        photo1Id
        photo2Id
        dependentCount
        source
        createdByUserId
        lastUpdatedDatetime
      }
      opportunities {
        contactId
        firstName
        lastName
        contactStatus
        phone
        email
        addressState
        opportunityId
        assignedUserName
        assignedUserRef
        createdByUserIdRef
        createdByUserName
        opportunityStatus
        stage
        stageId
        source
        lastUpdatedDatetime
        createdDatetime
        customField1
        customField2
        failedReasonCode
        carrierMemberCount
        carrierProvider
        carrierState
        agentFusionId
        dataOnly
        medicaidEnrolled
        expireSoon
        incomeOrEmployment
        moveMedicaidBenefit
        medicareEnrolled
        employmentStatus
        sepQualification
        sepPreviousZip
      }
      notes {
        noteId
        contactId
        noteText
        lastUpdatedDatetime
        createdDatetime
        userRef
        userName
      }
      dependents {
        createdDatetime
        dob
        firstName
        id
        lastName
        middleName
        ssn
        suffix
        contactId
      }
    }
  }  
`;


export const ACA_UPDATE_CONTACT = gql`
  mutation acaUpdateContact($data: AcaUpdateContactInput) {
    acaUpdateContact(data: $data) {
        success
        error
    }
  }
`;
export const ACA_UPDATE_OPPORTUNITY = gql`
    mutation acaUpdateOpportunity($data: AcaUpdateOpportunityInput) {
        acaUpdateOpportunity(data: $data) {
            success
            error
        }
    }
`;

export const ACA_CREATE_NOTE = gql`
    mutation acaCreateNote($data: AcaCreateNoteInput) {
        acaCreateNote(data: $data) {
            success
            error
            noteId
       }
    }
`;

export const ACA_GET_HISTORY = gql`
    mutation acaGetHistory($contactId: Int) {
        acaGetHistory(contactId: $contactId) {
            success
            error
            history {
                eventId
                createdDatetime
                userRef
                userName
                changeText
            }
       }
    }
`;

export const ACA_GET_PIPELINE_STAGES = gql`
    mutation acaGetPipelineStages($pipelineId: Int) {
        acaGetPipelineStages(pipelineId: $pipelineId) {
            success
            error
            stages {
                enrolled
                failed
                id
                name
                position
                closedOption
                documentsRequested {
                    id
                    name
                    possibleDocuments
                }
            }
       }
    }
`;

export const ACA_GET_CONTACTS = gql`
    mutation acaGetContacts($data: AcaGetContactsInput) {
        acaGetContacts(data: $data) {
            success
            error
            contacts {
                contactId
                firstName
                middleName
                lastName
                suffix
                status
                email
                phone
                createdDatetime
                lastUpdatedDatetime
                addressLine1
                addressLine2
                addressCity
                addressState
                addressZip
            }
            pagination {
                pageSize
                currentPage
                numOfPages
                totalCount
            }
       }
    }
`;
export const ACA_SEARCH = gql`
    mutation acaSearch($data: AcaSearchInput) {
        acaSearch(data: $data) {
            success
            error
            contacts {
                contactId
                firstName
                middleName
                lastName
                suffix
                status
                email
                phone
                createdDatetime
                lastUpdatedDatetime
                addressLine1
                addressLine2
                addressCity
                addressState
                addressZip
                opportunityCount
                lastOpportunity {
                    opportunityId
                    contactId
                    status
                    stageId
                    stageName
                    createdDatetime
                    lastUpdatedDatetime
                    carrierProvider
                    carrierState
                    carrierMemberCount
                    source
                    failedReasonCode
                    cancelledTerminated
                    assignedUserRef
                    assignedUserName
                    pipelineId
                    leadSignedPdfId
                    aorSignedPdfId
                    signatureFileId
                    customField1
                    customField2
                    verificationDate
                    agentFusionId
                    dataOnly
                    medicaidEnrolled
                    expireSoon
                    incomeOrEmployment
                    moveMedicaidBenefit
                    medicareEnrolled
                    employmentStatus
                    sepQualification
                    sepPreviousZip
                }
            }
            pagination {
                pageSize
                currentPage
                numOfPages
                totalCount
            }
       }
    }
`;

export const ACA_GET_PROVIDER_STATES = gql`
    mutation acaGetProviderStates {
        acaGetProviderStates {
            success
            error
            providerStates {
                state
                name
            }
       }
    }
`;

export const ACA_GET_COMPLIANCE_REASONS = gql`
    mutation AcaGetComplianceReasons {
        acaGetComplianceReasons {
            success
            error
            reasons { id description status }
        }
    }
`;

export const ACA_SET_COMPLIANCE_FLAG = gql`
    mutation AcaSetComplianceFlag($data: AcaSetComplianceFlagRequest!) {
        acaSetComplianceFlag(data: $data) { success error }
    }
`;
export const ACA_ADMIN_ADD_COMPLIANCE_REASON = gql`
    mutation AcaAdminAddComplianceReason($description: String) {
        acaAdminAddComplianceReason(description: $description) { success error }
    }
`;

export const ACA_ADMIN_SET_COMPLIANCE_REASON_STATUS = gql`
    mutation AcaAdminSetComplianceReasonStatus($id: Int!, $status: String!) {
        acaAdminSetComplianceReasonStatus(id: $id, status: $status) { success error }
    }
`;

export const ACA_GET_IMAGE_URL = gql`
    mutation acaGetImageUrl($imageId: Int) {
        acaGetImageUrl(imageId: $imageId) {
            success
            error
            url
            fileType
       }
    }
`;

export const ACA_SINGLE_UPLOAD = gql`
  mutation($file: Upload!) {
    acaSingleUpload(file: $file) {
      filename
      mimetype
      encoding
      url
      error
    }
  }
`;


export const ACA_UPLOAD_IMAGE = gql`
  mutation acaUploadImage($imageUrl: String, $imageFileType: String, $imageName: String) {
    acaUploadImage(imageUrl: $imageUrl, imageFileType: $imageFileType, imageName: $imageName) {
      success
      error
      imageId
    }
  }
`;

export const ACA_ADD_DEPENDENT = gql`
  mutation acaAddDependent($data: AcaAddDependentInput) {
    acaAddDependent(data: $data) {
      success
      error
      dependentId
    }
  }
`;
export const ACA_UPDATE_DEPENDENT = gql`
  mutation acaUpdateDependent($data: AcaUpdateDependentInput) {
    acaUpdateDependent(data: $data) {
      success
      error
    }
  }
`;
export const ACA_DELETE_DEPENDENT = gql`
  mutation acaDeleteDependent($data: AcaDeleteDependentInput) {
    acaDeleteDependent(data: $data) {
      success
      error
    }
  }
`;

export const ACA_ISSUE_IMAGE_REPLACEMENT = gql`
    mutation acaIssueImageReplacement($data: AcaImageReplacementInput) {
        acaIssueImageReplacement(data: $data) {
            success
            error
        }
    }
`;


export const ACA_CREATE_OPPORTUNITY = gql`
    mutation acaCreateOpportunity($data: AcaCreateOpportunityInput) {
        acaCreateOpportunity(data: $data) {
            success
            error
            opportunityId
            contactId
        }
    }
`;

export const ACA_UPDATE_OPPORTUNITIES = gql`
    mutation acaUpdateOpportunities($data: AcaUpdateOpportunitiesInput) {
        acaUpdateOpportunities(data: $data) {
            success
            error
        }
    }
`;
export const ACA_UPDATE_CONTACTS = gql`
    mutation acaUpdateContacts($data: AcaUpdateContactsInput) {
        acaUpdateContacts(data: $data) {
            success
            error
        }
    }
`;

export const ACA_BATCH_UPDATE = gql`
    mutation acaBatchUpdate($fileUrl: String) {
        acaBatchUpdate(fileUrl: $fileUrl) {
            success
            error
        }
    }
`;

export const ACA_BATCH_XLSX_UPLOAD = gql`
    mutation($file: Upload!) {
        acaUploadBatchXLSX(file: $file) {
            filename
            mimetype
            encoding
            url
            error
        }
    }
`;
